import axios from "axios";

const apiIndecx = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}customer-relationship/nps/v1`,
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiIndecx;
